import React from 'react';
import ThumbUp from 'material-ui-icons/ThumbUp';
import ThumbDown from 'material-ui-icons/ThumbDown';
import MonetizationOn from 'material-ui-icons/MonetizationOn';
import Clock from 'material-ui-icons/Timer';
import Tooltip from 'material-ui/Tooltip';
import { isNullOrUndefined } from 'util';
import { Typography } from 'material-ui';
import { translate } from 'react-i18next';
import { withStyles } from 'material-ui/styles';
import { DoRender } from '../Utils/shared';

const styles = theme => ({
    messageTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px'
    }
});

/**
 * Componente que renderiza el estado de las reservas con icono y color piola
 */
class ReservationStatusRender extends React.Component {

    constructor(props) {
        super(props);

        let size = this.props.size ? this.props.size : '24px';

        this.state = {
            color: 'green',
            ReservasStatusName: {
                C: this.props.t('BOOKINGS.STATE_CANCELED'),
                R: this.props.t('BOOKINGS.STATE_BOOKED'),
                P: this.props.t('BOOKINGS.STATE_ON_REQUEST'),
                F: this.props.t('BOOKINGS.STATE_BILLED')
            },
            ReservasStatusColor: {
                C: 'red',
                R: 'green',
                P: 'orange',
                F: 'green'
            },
            ReservasStatusIcon: {
                C: <ThumbDown style={{ color: 'white', width: size, height: size }} />,
                R: <ThumbUp style={{ color: 'white', width: size, height: size }} />,
                P: <Clock style={{ color: 'white', width: size, height: size }} />,
                F: <MonetizationOn style={{ color: 'white', width: size, height: size }} />
            },
        };
    }
    getToolTip(reservation) {
        if (isNullOrUndefined(reservation) || isNullOrUndefined(reservation.state)) {
            return '';
        }
        return this.state.ReservasStatusName[reservation.state];
    }
    getColor(reservation) {
        if (isNullOrUndefined(reservation)) {
            return 'grey';
        }
        return this.state.ReservasStatusColor[reservation.state];
    }
    getIcon(reservation) {
        if (isNullOrUndefined(reservation)) {
            return <ThumbDown />;
        }
        return this.state.ReservasStatusIcon[reservation.state];
    }

    render() {
        const { showPaymentStatus = false, message, classes, reservation, divPadding, divWidth, divHeight } = this.props;

        let padding = divPadding;
        if (!divPadding) {
            padding = '20px 0px 0px 20px';
        }

        let width = divWidth;
        if (!divWidth) {
            width = '48px';
        }

        let height = divHeight;
        if (!divHeight) {
            height = '46px';
        }


        return (
            reservation ?
                <div className={'thinText'} style={{
                    backgroundColor: this.getColor(reservation)
                }}>
                    <div style={{
                        backgroundColor: this.getColor(reservation),
                        padding: padding,
                        width: width,
                        height: height,
                        float: 'right'
                    }}>
                        <Tooltip title={this.getToolTip(reservation)}>
                            {this.getIcon(reservation)}
                        </Tooltip>
                    </div>
                    <DoRender if={showPaymentStatus && reservation.paymentStatus !== null}>
                        <span className={'PaymentStatusText ' + reservation.paymentStatus}>{this.props.t('COMMON.' + reservation.paymentStatus)}</span>
                    </DoRender>
                    {
                        message &&
                        <div style={{
                            padding: '20px 0px 0px 20px',
                            width: '170px', height: '44px', float: 'right'
                        }}>
                            <Typography className={classes.messageTitle}>
                                {message}
                            </Typography>
                        </div>
                    }
                </div> : ''
        );
    }
}
export default translate('translations')(withStyles(styles)(ReservationStatusRender));


// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationStatusRender.js